"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cassago-brianza": {
    "0c820c5c": [{
      "hkey": "237795ee",
      "slug": "cassago-brianza",
      "name": "Cassago Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "campi-asciutti": [{
      "hkey": "237795ee",
      "slug": "cassago-brianza",
      "name": "Cassago Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "19fc7047": [{
      "hkey": "237795ee",
      "slug": "cassago-brianza",
      "name": "Cassago Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "oriano": [{
      "hkey": "237795ee",
      "slug": "cassago-brianza",
      "name": "Cassago Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;